import { Input, inputChrome } from "."

// Ticket #4366. Selects take the same box as `Input.variants.primary` — 48px, 12px/8px padding, and the `baseStyle`
// 14px typography. This is deliberate: before the ticket both recipes carried the same 52px/16px geometry, so inputs
// and selects lined up by accident. Giving selects chrome only would leave them 4px taller with larger type next to
// an input in the same row (see the Date/Time and Attendees/Age pairs on /instore-bookingform/). Do not "restore" the
// old geometry. The explicit `_focus` inside `inputChrome` matters here: our `outline` key collides with Chakra's own
// `outline` variant and extendTheme merges the two, so without it a focused select keeps Chakra's `blue.500` shadow.
//
// Shared by reference between the `outline` and `address` variants — editing this object moves both.
const field = {
  ...inputChrome,
  h: "48px",
  px: "12px",
  py: "8px",
}

export const Select = {
  baseStyle: {
    field: {
      ...Input.baseStyle.field,
    },
  },
  sizes: {
    default: {},
  },
  variants: {
    outline: {
      field,
    },
    address: {
      field,
    },
    reviewsSort: {
      field: {
        fontSize: "1rem",
        lineHeight: 1.125,
        bgColor: "primary.white",
        pl: 4,
        py: 4,
      },
    },
  },
  defaultProps: {
    size: "default",
    variant: "outline",
  },
}
